import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LogImport } from '../model/log-import';

@Injectable({
  providedIn: "root"
})
export class LogImportService {
  constructor(
    private _restClientService: RestClientService,
    private http: HttpClient
  ) {}

  logImports() {
    return this._restClientService.load<LogImport[]>("log-import/imports");
  }

  logImportInfoById(logImportId: string) {
    return this._restClientService.load<LogImport>(
      "log-import/log-import-info-id?logImportId=" + logImportId
    );
  }

  importerFichier(logImportId) {
    return this._restClientService.load<any>(
      "log-import/importer-fichier?logImportId=" + logImportId
    );
  }
  logImportFiles(directory: string, search: string) {
    return this._restClientService.load<LogImport[]>(
      "log-import/import-directories?directory=" +
        directory +
        "&search=" +
        search
    );
  }

  getFiles(directory: string, search: string) {
    return this._restClientService.load<any>(
      "log-import/files?directory=" + directory + "&search=" + search
    );
  }

  upload(directory: string, file: File): Observable<HttpEvent<any>> {
    let formData: FormData = new FormData();
    formData.append("file", file);
    const req = new HttpRequest(
      "POST",
      environment.BACKEND_RACINE_URL +
        `log-import/upload?directory=` +
        directory,
      formData,
      {
        reportProgress: true,
        responseType: "json"
      }
    );
    return this.http.request(req);
  }

  uploadsimple(directory: string, file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append("file", file);

    const req = new HttpRequest(
      "POST",
      environment.BACKEND_RACINE_URL +
        `log-import/upload-simple?directory=` +
        directory,
      formData,
      {
        reportProgress: true,
        responseType: "json"
      }
    );

    return this.http.request(req);
  }

  deleteFile(directory: string, filename: string) {
    return this.http.delete(
      environment.BACKEND_RACINE_URL +
        `log-import/file?directory=` +
        directory +
        "&filename=" +
        filename
    );
  }

    deleteFileImport(id: string, directory: string, filename: string) {
        return this.http.delete(
            environment.BACKEND_RACINE_URL +
            `log-import/file?directory=` +
            directory +
            "&filename=" +
            filename +
            "&id=" +
            id
        );
    }

   
}      

    